<template>
  <div class="lx-transfer lx-flex-row">
    <div class="lx-transfer-item">
      <div class="lx-transfer-item-header lx-flex-row-center">
        <span class="header-title lx-flex-grow-1">已选择列</span>
        <span class="header-right lx-flex-shrink-0"><span class="deep">{{selectNum}}</span>/{{selectList.length}}</span>
      </div>
      <div class="lx-transfer-item-main">
        <lx-drag-list :list="selectList" @result="getSelectResult"></lx-drag-list>
      </div>
    </div>
    <div class="lx-handle-wrap lx-flex-row lx-mr16 lx-ml16">
      <el-button class="lx-mr16" type="primary" size="small" icon="el-icon-arrow-left" :disabled="noSelectNum === 0" @click="doLeft">到左边</el-button>
      <el-button type="primary" size="small" :disabled="selectNum === 0" @click="doRight">到右边<i class="el-icon-arrow-right el-icon--right"></i></el-button>
    </div>
    <div class="lx-transfer-item">
      <div class="lx-transfer-item-header lx-flex-row-center">
        <span class="header-title lx-flex-grow-1">未选择列</span>
        <span class="header-right lx-flex-shrink-0"><span class="deep">{{noSelectNum}}</span>/{{noSelectList.length}}</span>
      </div>
      <div class="lx-transfer-item-main">
        <lx-drag-list :list="noSelectList" @result="getNoSelectResult" :is-drag="false"></lx-drag-list>
      </div>
    </div>
  </div>
</template>
<script>
import LxDragList from "@/components/LxDragList/index";
export default {
  name: "LxTransfer",
  components: {
    LxDragList,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    }, // 全部表头
  },
  data() {
    return {
      selectList: [], //左侧区域
      // selectNum: 0, // 左侧区域已选中
      noSelectList: [], // 右侧区域
      // noSelectNum: 0, // 右侧区域已选中
    };
  },
  computed: {
    selectNum() {
      return this.filterCheck(this.selectList);
    },
    noSelectNum() {
      return this.filterCheck(this.noSelectList);
    },
  },
  watch: {
    // 全部表头数据，通过isShow判断是否为用户选择
    list: {
      handler(val) {
        val.forEach((item) => {
          this.$set(item, "isCheck", false);
        });
        this.selectList = val.filter((item) => item.isShow);
        this.noSelectList = val.filter((item) => !item.isShow);
      },
      immediate: true,
    },
    selectList: {
      handler(val) {
        this.$emit("result", val);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 筛选选中的
    filterCheck(list) {
      return list.filter((item) => item.isCheck).length;
    },
    // 获取左侧区域的操作结果
    getSelectResult(list) {
      this.selectList = list;
    },
    // 获取右侧区域的操作结果
    getNoSelectResult(list) {
      this.noSelectList = list;
    },
    // 到左边
    doLeft() {
      let noSelectList = this._.cloneDeep(this.noSelectList);
      let list = [];
      list = noSelectList.filter((item) => item.isCheck);
      this.noSelectList = noSelectList.filter((item) => !item.isCheck);
      list.forEach((item) => {
        item.isCheck = false;
        this.selectList.unshift(item);
      });
    },
    // 到右边
    doRight() {
      let selectList = this._.cloneDeep(this.selectList);
      let list = [];
      list = selectList.filter((item) => item.isCheck);
      this.selectList = selectList.filter((item) => !item.isCheck);
      list.forEach((item) => {
        item.isCheck = false;
        this.noSelectList.unshift(item);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.lx-transfer-item {
  width: 240px;
  height: 500px;
  overflow-y: auto;
  border-radius: 5px;
  border: 1px solid #ebeef5;
  .lx-transfer-item-header {
    height: 40px;
    padding: 0 14px;
    background-color: #f5f7fa;
    border: 1px solid #ebeef5;
    .header-title {
      color: #303133;
      font-size: 16px;
      font-weight: 400;
    }
    .header-right {
      color: #999;
      font-size: 12px;
      .deep {
        color: #8a8a8a;
        font-size: 12px;
      }
    }
  }
  .lx-transfer-item-main {
    padding: 10px 0;
  }
}
</style>